<template>
    <div>
        <v-img  alt="" contain class="page-header" src="@/assets/redcar/page-headers/employment.png" />
        <div class="px-4 pt-6">
            <div class="container desktop-container">
            <div class="row no-gutters">

                  <div class="col-12 sorting">
                    <small>{{hubbdata.apprenticeshiplist.labels.sort}}</small><br />
                    <v-btn-toggle
                        v-model="value"
                        v-on:change="jobsExpiring()"
                        color="accent-3"
                        label="Sort By"
                        small
                        class="toggle"
                        mandatory
                    >
                        <v-btn v-html="hubbdata.search.added" value="Added Date">

                        </v-btn>

                        <v-btn v-html="hubbdata.search.closing" value="Closing Date">

                        </v-btn>

                    </v-btn-toggle>
                </div>

                <div class="col-12">
                    <v-text-field
                        v-model="search"
                        class="pb-3 search-location"
                        :label="hubbdata.search.location"
                        clearable
                        small
                    ></v-text-field>

                </div>




            </div>




            </div>



            <v-chip
                v-for="(keyword, i) in keywords"
                :key="i"
                class="mr-2 mb-2"
                @click="setSearch(keyword)"
            >
                {{ keyword }}
            </v-chip>


        </div>

        <v-data-iterator
            :items="searching"
            :items-per-page.sync="itemsPerPage"
            :page.sync="page"
            :search="search"
            :sort-desc="sortDesc"
            hide-default-footer
            class="opps-data items-wrapper"
            >


            <template slot="no-data">
                <div class="no-results">
                    <h3>{{hubbdata.apprenticeshiplist.labels.noresults}}</h3>
                </div>
            </template>

            <template v-slot:default="props">
            <OpportunityItem
                :key="opportunity.id"
                v-for="opportunity in props.items"
                :opportunity = opportunity
            />
            </template>
            <template v-slot:footer>
                <div class="opps-footer" v-show="searching.length > 0">
                <v-row
                class="mt-2"
                align="center"
                justify="center"
                >
                    <span
                        class="mr-4
                        black--text"
                    >
                        {{hubbdata.apprenticeshiplist.pagination.page}} {{ page }} {{hubbdata.apprenticeshiplist.pagination.of}} {{ numberOfPages }}
                    </span>
                    <v-btn
                        fab
                        dark
                        color="primary "
                        class="mr-1"
                        @click="formerPage"
                    >
                        <div class="sr-only">Previous Page</div>
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn
                        fab
                        dark
                        color="primary "
                        class="ml-1"
                        @click="nextPage"
                    >
                        <div class="sr-only">Next Page</div>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-row>
                </div>
            </template>
        </v-data-iterator>


    </div>
</template>

<style lang="scss">

    .no-results {
        padding: 20px;
    }

    .search-location {
        margin-top: 25px;
    }

    .v-label {
        font-size: 14px;

        @media screen and (min-width: 960px) {
          font-size: 16px;
        }
    }
    .opps-top-text {
        border-radius: 5px;
        margin-bottom: 0px !important;
        a {
            color: black !important;
            text-decoration: underline;
        }
    }

    .toggle button {
        font-size: 9px !important;
        width: 75px;
        white-space: normal;
    }
    .sorting {
        text-align: right;
    }


    .opps-data {
        padding-bottom: 60px;
    }

    .no-gutters {
        margin-right: 0;
        margin-left: 0;

        > .col,
        > [class*="col-"] {
            padding-right: 0;
            padding-left: 0;
        }
        }

    .opps-footer {
        position: fixed;
        bottom: 0px;
        background-color: $light !important;
        padding-bottom: calc(var(--sab) + 25px);
        width: 100%;
        left: 0px;
        z-index: 5;
        @media (min-width: 800px) {
            bottom: 0px;
        }

    }

    .v-data-footer__select {
        margin-right: 0px;
    }

    .v-input--hide-details {
        margin: 9px 0px 9px 5px !important;
    }
.v-text-field__details {
    display: none;
}

 .opportunity__link {
    text-decoration: none !important;

    .v-card__actions {
        @media (max-width: 576px) {
            display: flex;
            justify-content: center;
        }

        @media (min-width: 577px) {
            margin-left: 8px;
        }
    }

    .email {
      width: 165px;
      white-space: normal;
    }

    .v-btn--outlined {
        background-color: #e9e8e6;
        outline: 1px solid $dark;
        color: $dark!important;
        font-weight: 18px;
        margin: 0 auto;
        font-weight: bold;
    }
  }



    .headline p {
        white-space: pre-wrap;
     }

    .v-icon {
     color: white;
      font-size: 40px;
    }

  @media screen and (min-width: 960px) {
    .page-header {
      height: 300px;
      .v-image__image {
        height: 300px;
        background-size: cover;
      }
    }

    .desktop-container {
      max-width: 750px;
    }

    .items-wrapper {
      max-width: 750px;
    }
  }

  .opps-footer {
    .row {
      @media screen and (min-width: 960px) {
        width: calc(100vw - 256px);
        margin-left: 200px;
      }
    }
  }


</style>
<script>
import hubbdata from "@/hubbdata";
// import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';
import moment from 'moment';
// import Opportunity from '../../views/Opportunity.vue';
import OpportunityItem from '@/components/Opportunities/OpportunityItem.vue';


export default {
    name: "OpportunitiesList",

    data() {
        return {
            jobs: [],
            search: '',
            itemsPerPageArray: [4, 8, 12],
            filter: {},
            sortDesc: false,
            page: 1,
            itemsPerPage: 10,
            sortBy: 'name',
            sorting: false,
            items: ['Added Date', 'Closing Date'],
            value: 'Added Date',
        }
    },
    components: {
        OpportunityItem
    },
    methods: {
        //handleContentClick is in global sharedMethods mixin
        setSearch(keyword) {
            this.search = keyword
        },

        nextPage () {
            window.scrollTo({
                top: 210,
                behavior: 'smooth'
            });
            if (this.page + 1 <= this.numberOfPages) this.page += 1
        },
        formerPage () {
            window.scrollTo({
                top: 210,
                behavior: 'smooth'
            });
            if (this.page - 1 >= 1) this.page -= 1
        },
        updateItemsPerPage (number) {
            this.itemsPerPage = number
        },

        jobsExpiring() {
            if (this.value === 'Closing Date' || this.value === this.hubbdata.search.closing) {
                let jobs = []
                let nullJobs = []
                for (let job of this.jobs) {
                    if (job.closing_date != null) {
                        jobs.push(job)
                    }
                    else  {
                        // lets put all the null jobs here so we can add them at the end
                        nullJobs.push(job)
                    }
                }
                jobs.sort((a, b) => +(a.closing_date>b.closing_date)||-(a.closing_date<b.closing_date));
                jobs = jobs.concat(nullJobs)
                this.jobs = jobs
                this.sorting = true
            }
            else {
                this.jobs = hubbdata.state.opportunities
                this.sorting = false

            }


            // this.expireResults = true;
            // this.offerTotal();
        },
    },
    created() {
        this.jobs = hubbdata.state.opportunities
        this.items = [this.hubbdata.search.added, this.hubbdata.search.closing]
    },
    filters: {
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY');
            }
        }
    },

    computed: {
        opportunities() {
            return hubbdata.state.opportunities
        },
        hubbdata() {
          return hubbdata.getters.translations;
        },

        numberOfPages () {
            return Math.ceil(this.searching.length / this.itemsPerPage)
        },

        keywords () {

        if (!this.search) return []


        const keywords = []

        for (const search of this.searching) {
          if (search.location !== null && search.location !== '' && !keywords.includes(search.location) && search.location.length < 20) {
            keywords.push(search.location)
          }
        }

        return keywords
      },
      searching () {
        if (!this.search) return this.jobs
        const search = this.search.toLowerCase()

        return this.jobs.filter(item => {
          var text = ""
          if (item.location !== null) {
            text = item.location.toLowerCase()

          }

          return text.indexOf(search) > -1
        })

      },

    }
}

</script>
